import {
  EmployeeSoftwareMembershipDocument,
  SoftwareManagementCreateSoftwareSetupDocument,
  SoftwareManagementCreateSoftwareSetupMutation,
  SoftwareManagementCreateSoftwareSetupMutationVariables,
  SoftwareManagementGetSoftwareDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateSoftwareSetup = () => {
  const [createSoftwareSetup, { loading }] = useMutation(
    SoftwareManagementCreateSoftwareSetupDocument,
    {
      extractorFn: (data: SoftwareManagementCreateSoftwareSetupMutation) =>
        data.softwareManagementMutations.createSoftwaremanagementSoftwareSetup,
    }
  )

  return {
    create(variables: SoftwareManagementCreateSoftwareSetupMutationVariables) {
      return createSoftwareSetup({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: SoftwareManagementGetSoftwareDocument,
            variables: {},
          },
          {
            query: EmployeeSoftwareMembershipDocument,
            variables: {},
          },
        ],
      })
    },
    loading,
  }
}
